// extracted by mini-css-extract-plugin
export default {"container":"ContractListPage_container__ChsN1","title":"ContractListPage_title__9lixa"};